import { useEffect, useState } from "react"

import useLogin from "./useLogin"
import Register from "./Register"

const dataUrl = process.env.REACT_APP_DATA_JSON_URL

export default function LoginToPlay({ onClose }) {
  const { user, setUser, handleLogin, errorMessage, processingLogin } =
    useLogin()
  const [loading, setLoading] = useState(null)

  const [isShowLogin, setIsShowLogin] = useState(true)
  const [showPassword, setShowPassword] = useState(false)
  const [isShowForgotPass, setIsShowForgotPass] = useState(false)
  const [isShowRegister, setIsShowRegister] = useState(false)
  const [alertMsg, setAlertMsg] = useState("")
  const [successAlertMsg, setSuccessAlertMsg] = useState("")
  const [phoneNo, setPhoneNo] = useState("")
  const [email, setEmail] = useState("")
  const [showFormOtp, setShowFormOtp] = useState(false)
  const [showFormEmail, setShowFormEmail] = useState(false)
  const [otpEmailSent, setOtpEmailSent] = useState(false)
  const [otpSent, setOtpSent] = useState(false)

  // These states are added for changing password.
  const [otp, setOtp] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [passwordChanged, setPasswordChanged] = useState(false)
  const [mobileFromEmailOtp, setMobileFromEmailOtp] = useState("")

  const handleBackBtn = () => {
    setIsShowForgotPass(false)
    setIsShowLogin(true)
    setOtpSent(false)
    setPasswordChanged(false)
    setPhoneNo("")
    setEmail("")
    setAlertMsg("")
    setShowFormOtp(false)
    setShowFormEmail(false)
  }

  const handleBackChangeOTP = () => {
    setIsShowForgotPass(true)
    setShowFormOtp(false)
    setShowFormEmail(false)
    setEmail("")
    setAlertMsg("")
  }

  const HandleOpenRegister = () => {
    setIsShowLogin(false)
    setIsShowRegister(true)
  }

  const handleOpenForgotPass = () => {
    setIsShowLogin(false)
    setIsShowForgotPass(true)
  }

  const handleShowFormOtp = () => {
    setShowFormOtp(true)
    setIsShowForgotPass(false)
  }

  const handleShowFormEmail = () => {
    setShowFormEmail(true)
    setIsShowForgotPass(false)
  }

  const handleChangePass = async (e) => {
    e.preventDefault()
    // Ensure the new password and confirmation match
    if (newPassword !== confirmPassword) {
      setAlertMsg("Passwords do not match.")
      return
    }

    const formData = new URLSearchParams()
    formData.append("mobile", phoneNo)
    formData.append("cmd", "changepasswordWithOTP")
    formData.append("otp", otp)
    formData.append("password", newPassword)
    formData.append("confirmpassword", confirmPassword)

    try {
      const response = await fetch(dataUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: formData.toString(),
      })

      const data = await response.json()

      if (data.s) {
        setSuccessAlertMsg(data.s)
        // Clear the inputs once successful
        setOtp("")
        setNewPassword("")
        setConfirmPassword("")
        setAlertMsg("")
        setPasswordChanged(true)
      } else {
        setAlertMsg(data.e || "Password change failed. Please try again.")
      }
    } catch (error) {
      console.error("Error changing password:", error)
      setAlertMsg("An error occurred. Please try again.")
    }
  }

  const handleChangePassEmail = async (e) => {
    e.preventDefault()
    // Ensure the new password and confirmation match
    if (newPassword !== confirmPassword) {
      setAlertMsg("Passwords do not match.")
      return
    }

    const formData = new URLSearchParams()
    formData.append("email", email)
    formData.append("cmd", "changepasswordWithOTP")
    formData.append("mobile", mobileFromEmailOtp)
    formData.append("otp", otp)
    formData.append("password", newPassword)
    formData.append("confirmpassword", confirmPassword)

    try {
      const response = await fetch(dataUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: formData.toString(),
      })

      const data = await response.json()

      if (data.s) {
        setSuccessAlertMsg(data.s)
        // Clear the inputs once successful
        setOtp("")
        setNewPassword("")
        setConfirmPassword("")
        setAlertMsg("")
        setPasswordChanged(true)
      } else {
        setAlertMsg(data.e || "Password change failed. Please try again.")
      }
    } catch (error) {
      console.error("Error changing password:", error)
      setAlertMsg("An error occurred. Please try again.")
    }
  }

  const handleGetOTP = async (e) => {
    e.preventDefault()
    let message = `OTP sent to [${phoneNo}]`

    // Validate phone number: Must be 11 characters and start with "0"
    if (phoneNo.length !== 11 || !phoneNo.startsWith("0")) {
      message = "Invalid Phone Number"
      setAlertMsg(message)
      return
    }

    setLoading("phone")

    const formData = new URLSearchParams()
    formData.append("mobile", phoneNo)
    formData.append("cmd", "getOTP")

    try {
      const response = await fetch(dataUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: formData.toString(),
      })

      const data = await response.json()

      if (data.s === true) {
        setAlertMsg(message)
        setOtpSent(true)
      } else {
        message = "Invalid Phone Number"
        if (data.emsg) {
          message = data.emsg
        }
        setAlertMsg(message)
      }
    } catch (error) {
      console.error("Error fetching OTP:", error)
      setAlertMsg("An error occurred. Please try again.")
    } finally {
      setLoading(null)
    }
  }

  const handleGetEmailOTP = async (e) => {
    e.preventDefault()
    let message = `OTP sent to [${email}]`

    setLoading("email")

    const formData = new URLSearchParams()
    formData.append("email", email.trim())
    formData.append("cmd", "getEmailOTP")

    try {
      const response = await fetch(dataUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: formData.toString(),
      })

      const data = await response.json()

      if (data.s === true) {
        setAlertMsg(message)
        setOtpEmailSent(true)
        setMobileFromEmailOtp(data.mobile)
      } else {
        message = "Invalid Email"
        if (data.s) {
          message = data.s
        }
        setAlertMsg(message)
      }
    } catch (error) {
      console.error("Error fetching Email:", error)
      setAlertMsg("An error occurred. Please try again.")
    } finally {
      setLoading(null)
    }
  }

  // Auto-hide local alerts after 6 seconds
  useEffect(() => {
    if (!alertMsg) return
    const t = setTimeout(() => setAlertMsg(""), 6000)
    return () => clearTimeout(t)
  }, [alertMsg])

  useEffect(() => {
    if (!successAlertMsg) return
    const t = setTimeout(() => setSuccessAlertMsg(""), 6000)
    return () => clearTimeout(t)
  }, [successAlertMsg])

  return (
    <div className="fgh-login-modal">
      <div className="fgh-login-modal-content">
        <div className="fgh-login-form-container">
          <div className="fgh-login-banner">
            <img
              src="/images/fun-hub-gaming-new.webp?v=1"
              alt="FGH Fun Gaming Hub login page with mascots"
            />
          </div>
          <button className="fgh-login-modal-close-btn">
            <img
              src="/images/icon/close-btn.webp"
              alt="Close"
              onClick={onClose}
            />
          </button>
          <div className="fgh-login-container">
            <img
              src="/images/icon/fgh-logo.webp"
              alt="FGH Fun Gaming Hub - Logo"
              className="login-logo"
            />
            {isShowLogin && (
              <div className="fgh-login-module">
                <form
                  className="fgh-form-login"
                  onSubmit={handleLogin}
                  autoComplete="off"
                >
                  <h2 className="fgh-login-reg">Sign into your account</h2>
                  <input
                    type="text"
                    placeholder="Username"
                    value={user.username}
                    onChange={(e) =>
                      setUser({ ...user, username: e.target.value })
                    }
                    className="fgh-form-input fgh-input-username"
                  />
                  <div className="fgh-input-password-field">
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      value={user.password}
                      onChange={(e) =>
                        setUser({ ...user, password: e.target.value })
                      }
                      className="fgh-form-input"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="fgh-password-btn"
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      {showPassword ? (
                        <img
                          src="/images/icon/hide-password.webp"
                          alt="Hide Password"
                          className="password-icon-status"
                        />
                      ) : (
                        <img
                          src="/images/icon/reveal-password.webp"
                          alt="Show Password"
                          className="password-icon-status"
                        />
                      )}
                    </button>
                  </div>
                  <div className="forgot-password-remember-me-container">
                    <span
                      className="forgot-password-link"
                      onClick={handleOpenForgotPass}
                    >
                      Forgot Password?
                    </span>
                  </div>
                  <button
                    type="submit"
                    className={`fgh-form-login-btn fgh-normal-button ${
                      user.username.trim() === "" || user.password.trim() === ""
                        ? "disabled"
                        : ""
                    }`}
                    disabled={
                      user.username.trim() === "" || user.password.trim() === ""
                    }
                  >
                    {processingLogin ? "Processing ..." : "Login"}
                  </button>
                  {errorMessage && (
                    <div className="error-popup">{errorMessage}</div>
                  )}
                </form>
                <button
                  className="fgh-register-btn"
                  onClick={HandleOpenRegister}
                >
                  Register Now
                </button>
              </div>
            )}
            {isShowForgotPass && (
              <div className="fgh-forgot-password-module">
                {!otpSent ? (
                  <form
                    className="fgh-forgot-password"
                    autoComplete="off"
                    onSubmit={handleGetOTP}
                  >
                    <h2 className="fgh-login-reg">Change Password Via</h2>
                    <div className="fgh-forgot-pass-container">
                      <button
                        className="fgh-forgot-pass-button"
                        onClick={handleShowFormEmail}
                      >
                        Email
                      </button>
                      <p className="fgh-separator">
                        <span>or</span>
                      </p>
                      <button
                        className="fgh-forgot-pass-button"
                        onClick={handleShowFormOtp}
                      >
                        SMS OTP
                      </button>
                    </div>
                    <button className="fgh-back-btn" onClick={handleBackBtn}>
                      Back to Login
                    </button>
                  </form>
                ) : (
                  <div id="forgotpassword-2">
                    <div className="fgh-forgot-password-module">
                      <form
                        autoComplete="off"
                        className="fgh-change-password"
                        onSubmit={handleChangePass}
                      >
                        <h2>Change Password</h2>
                        {alertMsg && (
                          <div id="otpAlert">
                            <p>{alertMsg}</p>
                          </div>
                        )}
                        <input
                          name="mobile"
                          type="hidden"
                          className="fgh-form-input"
                          autoComplete="off"
                          value={phoneNo}
                        />
                        <input
                          name="otp"
                          type="number"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          inputMode="numeric"
                          className="fgh-form-input"
                          placeholder="OTP Pin"
                          autoComplete="off"
                          disabled={passwordChanged}
                        />
                        <input
                          name="password"
                          type="password"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          className="fgh-form-input"
                          placeholder="New Password"
                          autoComplete="off"
                          disabled={passwordChanged}
                        />
                        <input
                          name="confirmpassword"
                          type="password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          className="fgh-form-input"
                          placeholder="Confirm New Password"
                          autoComplete="off"
                          disabled={passwordChanged}
                        />
                        {successAlertMsg && (
                          <div id="otpAlert" className="changed-pass">
                            <p>{successAlertMsg}</p>
                          </div>
                        )}
                        <div className="fgh-forgot-pass-btn">
                          {!passwordChanged && (
                            <button
                              className={`fgh-normal-button change-password-btn ${
                                newPassword.trim() === "" ||
                                confirmPassword.trim() === "" ||
                                otp.trim() === ""
                                  ? "disabled"
                                  : ""
                              }`}
                            >
                              Change Password
                            </button>
                          )}
                          {passwordChanged && (
                            <button
                              className="fgh-normal-button"
                              onClick={handleBackBtn}
                            >
                              Back to Login
                            </button>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            )}

            {showFormOtp && (
              <>
                {!otpSent ? (
                  <form
                    className="fgh-forgot-password"
                    autoComplete="off"
                    onSubmit={handleGetOTP}
                  >
                    <h2 className="fgh-login-reg">Change Password Via OTP</h2>
                    <p className="fgh-sub-title">
                      *Please input your registered number
                    </p>
                    <input
                      type="text"
                      placeholder="Example: 09123456789"
                      className="fgh-form-input"
                      id="mobile"
                      value={phoneNo}
                      onChange={(e) => {
                        const value = e.target.value
                        if (/^\d*$/.test(value)) {
                          setPhoneNo(value)
                        }
                      }}
                      inputMode="numeric"
                      maxLength={11}
                    />
                    <input name="otp" type="hidden" value="" />
                    <input name="password" type="hidden" value="" />
                    <input name="confirmpassword" type="hidden" value="" />
                    <div className="fgh-forgot-pass-btn">
                      <button
                        className={`fgh-normal-button get-otp-btn ${phoneNo.trim() === "" || loading ? "disabled" : ""}`}
                        disabled={phoneNo.trim() === "" || loading === "phone"}
                      >
                        {loading === "phone" ? "Sending..." : "Get OTP"}
                      </button>
                      <button
                        type="button"
                        className={`fgh-back-to-login`}
                        onClick={handleBackChangeOTP}
                      >
                        Back
                      </button>
                    </div>
                  </form>
                ) : (
                  <div id="forgotpassword-2">
                    <div className="fgh-forgot-password-module">
                      <form
                        autoComplete="off"
                        className="fgh-change-password"
                        onSubmit={handleChangePass}
                      >
                        <h2>Change Password</h2>
                        {alertMsg && (
                          <div id="otpAlert">
                            <p>{alertMsg}</p>
                          </div>
                        )}
                        <input
                          name="mobile"
                          type="hidden"
                          className="fgh-form-input"
                          autoComplete="off"
                          value={phoneNo}
                        />
                        <input
                          name="otp"
                          type="number"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          inputMode="numeric"
                          className="fgh-form-input"
                          placeholder="OTP Pin"
                          autoComplete="off"
                          disabled={passwordChanged}
                        />
                        <input
                          name="password"
                          type="password"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          className="fgh-form-input"
                          placeholder="New Password"
                          autoComplete="off"
                          disabled={passwordChanged}
                        />
                        <input
                          name="confirmpassword"
                          type="password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          className="fgh-form-input"
                          placeholder="Confirm New Password"
                          autoComplete="off"
                          disabled={passwordChanged}
                        />
                        {successAlertMsg && (
                          <div id="otpAlert" className="changed-pass">
                            <p>{successAlertMsg}</p>
                          </div>
                        )}
                        <div className="fgh-forgot-pass-btn">
                          {!passwordChanged && (
                            <button
                              className={`fgh-normal-button change-password-btn ${
                                newPassword.trim() === "" ||
                                confirmPassword.trim() === "" ||
                                otp.trim() === ""
                                  ? "disabled"
                                  : ""
                              }`}
                            >
                              Change Password
                            </button>
                          )}
                          {passwordChanged && (
                            <button
                              className="fgh-normal-button"
                              onClick={handleBackBtn}
                            >
                              Back to Login
                            </button>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </>
            )}

            {showFormEmail && (
              <>
                {!otpEmailSent ? (
                  <form
                    className="fgh-forgot-password"
                    autoComplete="off"
                    onSubmit={handleGetEmailOTP}
                  >
                    <h2 className="fgh-login-reg">Change Password Via Email</h2>
                    <p className="fgh-sub-title">
                      *Please input your registered email
                    </p>
                    <input
                      type="email"
                      placeholder="Example: user@example.com"
                      className="fgh-form-input"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    {alertMsg && (
                      <div
                        className="fgh-sub-title"
                        style={{
                          textAlign: "center",
                          width: "100%",
                        }}
                      >
                        <p>{alertMsg}</p>
                      </div>
                    )}
                    <input name="otp" type="hidden" value="" />
                    <input name="password" type="hidden" value="" />
                    <input name="confirmpassword" type="hidden" value="" />
                    <div className="fgh-forgot-pass-btn">
                      <button
                        className={`fgh-normal-button get-otp-btn ${email.trim() === "" || loading ? "disabled" : ""}`}
                        disabled={email.trim() === "" || loading === "email"}
                      >
                        {loading === "email" ? "Sending..." : "Send OTP"}
                      </button>
                      <button
                        type="button"
                        className={`fgh-back-to-login`}
                        onClick={handleBackChangeOTP}
                      >
                        Back
                      </button>
                    </div>
                  </form>
                ) : (
                  <div id="forgotpassword-2">
                    <div className="fgh-forgot-password-module">
                      <form
                        autoComplete="off"
                        className="fgh-change-password"
                        onSubmit={handleChangePassEmail}
                      >
                        <h2>Change Password</h2>
                        {alertMsg && (
                          <div id="otpAlert">
                            <p>{alertMsg}</p>
                          </div>
                        )}
                        <input
                          name="email"
                          type="hidden"
                          className="fgh-form-input"
                          autoComplete="off"
                          value={email}
                        />
                        <input
                          name="mobile"
                          type="hidden"
                          className="fgh-form-input"
                          autoComplete="off"
                          value={mobileFromEmailOtp}
                        />
                        <input
                          name="otp"
                          type="number"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          inputMode="numeric"
                          className="fgh-form-input"
                          placeholder="OTP Pin"
                          autoComplete="off"
                          disabled={passwordChanged}
                        />
                        <input
                          name="password"
                          type="password"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          className="fgh-form-input"
                          placeholder="New Password"
                          autoComplete="off"
                          disabled={passwordChanged}
                        />
                        <input
                          name="confirmpassword"
                          type="password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          className="fgh-form-input"
                          placeholder="Confirm New Password"
                          autoComplete="off"
                          disabled={passwordChanged}
                        />
                        {successAlertMsg && (
                          <div id="otpAlert" className="changed-pass">
                            <p>{successAlertMsg}</p>
                          </div>
                        )}
                        <div className="fgh-forgot-pass-btn">
                          {!passwordChanged && (
                            <button
                              className={`fgh-normal-button change-password-btn ${
                                newPassword.trim() === "" ||
                                confirmPassword.trim() === "" ||
                                otp.trim() === ""
                                  ? "disabled"
                                  : ""
                              }`}
                            >
                              Change Password
                            </button>
                          )}
                          {passwordChanged && (
                            <button
                              className="fgh-normal-button"
                              onClick={handleBackBtn}
                            >
                              Back to Login
                            </button>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </>
            )}
            {/* 
            {isShowForgotPass && (
              <div className="fgh-forgot-password-module">
                {!otpSent ? (
                  <form
                    className="fgh-forgot-password"
                    autoComplete="off"
                    onSubmit={handleGetOTP}
                  >
                    <h2 className="fgh-login-reg">Forgot Password</h2>
                    <input
                      type="text"
                      placeholder="Example: 09123456789"
                      className="fgh-form-input"
                      id="mobile"
                      value={phoneNo}
                      onChange={(e) => {
                        const value = e.target.value
                        if (/^\d*$/.test(value)) {
                          setPhoneNo(value)
                        }
                      }}
                      inputMode="numeric"
                      maxLength={11}
                    />
                    <input name="otp" type="hidden" value="" />
                    <input name="password" type="hidden" value="" />
                    <input name="confirmpassword" type="hidden" value="" />
                    <div className="fgh-forgot-pass-btn">
                      <button
                        className={`fgh-normal-button get-otp-btn ${
                          phoneNo.trim() === "" ? "disabled" : ""
                        }`}
                      >
                        Get OTP
                      </button>
                      <button
                        type="button"
                        className={`fgh-back-to-login`}
                        onClick={handleBackBtn}
                      >
                        Back to Login
                      </button>
                    </div>
                  </form>
                ) : (
                  <div id="forgotpassword-2">
                    <div className="fgh-forgot-password-module">
                      <form
                        autoComplete="off"
                        className="fgh-change-password"
                        onSubmit={handleChangePass}
                      >
                        <h2>Change Password</h2>
                        {alertMsg && (
                          <div id="otpAlert">
                            <p>{alertMsg}</p>
                          </div>
                        )}
                        <input
                          name="mobile"
                          type="hidden"
                          className="fgh-form-input"
                          autoComplete="off"
                          value={phoneNo}
                        />
                        <input
                          name="otp"
                          type="number"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          inputMode="numeric"
                          className="fgh-form-input"
                          placeholder="OTP Pin"
                          autoComplete="off"
                          disabled={passwordChanged}
                        />
                        <input
                          name="password"
                          type="password"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          className="fgh-form-input"
                          placeholder="New Password"
                          autoComplete="off"
                          disabled={passwordChanged}
                        />
                        <input
                          name="confirmpassword"
                          type="password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          className="fgh-form-input"
                          placeholder="Confirm New Password"
                          autoComplete="off"
                          disabled={passwordChanged}
                        />
                        {successAlertMsg && (
                          <div id="otpAlert" className="changed-pass">
                            <p>{successAlertMsg}</p>
                          </div>
                        )}
                        <div className="fgh-forgot-pass-btn">
                          {!passwordChanged && (
                            <button
                              className={`fgh-normal-button change-password-btn ${
                                newPassword.trim() === "" ||
                                confirmPassword.trim() === "" ||
                                otp.trim() === ""
                                  ? "disabled"
                                  : ""
                              }`}
                            >
                              Change Password
                            </button>
                          )}
                          {passwordChanged && (
                            <button
                              className="fgh-normal-button"
                              onClick={handleBackBtn}
                            >
                              Back to Login
                            </button>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            )} */}
            {isShowRegister && (
              <Register
                onOpenLogin={() => {
                  setIsShowLogin(true)
                  setIsShowRegister(false)
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
